import SelectBloedRisico from "../../../../src/components/content/SelectBloedRisico";
import * as React from 'react';
export default {
  SelectBloedRisico,
  React
};